
(function () {
  function init() {
    if (typeof gsap === 'undefined') return;

    if (typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
    } else {

      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var EASE = 'power2.out';
    var DURATION = 0.7;
    var Y_OFFSET = 28;
    var STAGGER = 0.09;

    var singles = [];
    var groups = new Map();
    var viewportHeight = window.innerHeight;

    document.querySelectorAll('[data-animate]').forEach(function (el) {
      /* Lo que ya está en pantalla al cargar no se oculta: ocultarlo retrasa el LCP hasta que corre GSAP. */
      var rect = el.getBoundingClientRect();
      if (rect.top < viewportHeight && rect.bottom > 0) return;

      var group = el.closest('[data-animate-group]');
      if (group) {
        if (!groups.has(group)) groups.set(group, []);
        groups.get(group).push(el);
      } else {
        singles.push(el);
      }
    });

    singles.forEach(function (el) {
      gsap.from(el, {
        opacity: 0,
        y: Y_OFFSET,
        duration: DURATION,
        ease: EASE,
        clearProps: 'transform,opacity',
        scrollTrigger: {
          trigger: el,
          start: 'top 88%',
          once: true
        }
      });
    });

    groups.forEach(function (items, group) {
      gsap.from(items, {
        opacity: 0,
        y: Y_OFFSET,
        duration: DURATION,
        ease: EASE,
        stagger: STAGGER,
        clearProps: 'transform,opacity',
        scrollTrigger: {
          trigger: group,
          start: 'top 85%',
          once: true
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
